import { render, staticRenderFns } from "./UserBetweenStatus.vue?vue&type=template&id=27951a80&"
import script from "./UserBetweenStatus.vue?vue&type=script&lang=js&"
export * from "./UserBetweenStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports